import { WeenatColor, fromColorPathToColor } from '@weenat/theme'
import { FC } from 'react'
import { useCursorContext } from './CursorContext'

interface CursorProps {
  color?: WeenatColor
  isChartRestricted: boolean
}

interface DumbCursorProps extends CursorProps {
  height: number | undefined
  marginBottom: number | undefined
  cursorPos: { x: number; y: number } | undefined
  isCursorXBeforeNow: boolean
}

export const DumbCursor: FC<DumbCursorProps> = ({
  height,
  marginBottom,
  cursorPos,
  isCursorXBeforeNow,
  color = 'grayscale.black',
  isChartRestricted
}) => {
  const x = cursorPos?.x ?? 0

  return cursorPos && (!isChartRestricted || !isCursorXBeforeNow) ? (
    <>
      <g transform={`translate(${x}, 0)`}>
        <line
          strokeWidth={1}
          stroke={fromColorPathToColor(color)}
          x1={0}
          x2={0}
          y1={(height ?? 0) - (marginBottom ?? 0)}
          y2={0}
          strokeLinecap='round'
        />
      </g>
    </>
  ) : null
}

const Cursor: FC<CursorProps> = ({ color = 'grayscale.black', isChartRestricted }) => {
  const { height, marginBottom, cursorPos, isCursorXBeforeNow } = useCursorContext()

  return (
    <DumbCursor
      cursorPos={cursorPos}
      height={height}
      marginBottom={marginBottom}
      isCursorXBeforeNow={isCursorXBeforeNow}
      isChartRestricted={isChartRestricted}
      color={color}
    />
  )
}

export default Cursor
